import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HighlightedResult } from '@assetaccountant/core/models/azure-search.models';
import {
  RateLookupBase,
  RateLookupResult,
} from '@assetaccountant/core/services/depreciation.service';

@Component({
  selector: 'app-depreciation-lookup-search-item',
  templateUrl: './depreciation-lookup-search-item.component.html',
  styleUrls: ['./depreciation-lookup-search-item.component.scss'],
  standalone: false,
})
export class DepreciationLookupSearchItemComponent {
  @Input() rates: string[] = [];
  @Input() result: HighlightedResult<RateLookupResult>;

  @Output() selectItem = new EventEmitter<RateLookupResult>();

  onSelect(alternate?: RateLookupBase) {
    this.selectItem.emit(
      alternate
        ? {
            ...this.result,
            ...alternate,
          }
        : this.result,
    );
  }
}
